import { CodeEditorSegmegment } from "@/api/dto/CodeEditor";
import { CreateReviewRequest, UpdateReviewRequest, ReviewResponse } from "@/api/dto/ReviewCorporate";

// view のレビューフォーム型
export interface CorporateReviewForm {
  dealId: string | null;
  dealStatus: string;
  title: string;
  purchaseOverview: string;
  codeEditor: CodeEditorSegmegment[];
  amount: number;
  tags: string;
  createDate: Date | string;
  dealType: string;
  githubUrl: string | null;
  fileUrl: string | null;
  language: string;
  projectName: string;
  projectIconUrl: string;
  projectId: string;
}

// レビューフォームからレビュー作成リクエストに変換
export const toCreateReviewRequestFromReviewForm = (
  formData: CorporateReviewForm,
  dealStatus: string,
): CreateReviewRequest => {
  return {
    title: formData.title,
    purchaseOverview: formData.purchaseOverview,
    tags: formData.tags,
    codeEditor: formData.codeEditor,
    dealType: formData.dealType,
    githubUrl: formData.githubUrl,
    projectId: formData.projectId,
    language: formData.language,
    dealStatus: dealStatus,
  };
};

// レビューフォームからレビュー更新リクエストに変換
export const toUpdateReviewRequestFromReviewForm = (
  formData: CorporateReviewForm,
  dealStatus: string,
): UpdateReviewRequest => {
  return {
    title: formData.title,
    purchaseOverview: formData.purchaseOverview,
    tags: formData.tags,
    codeEditor: formData.codeEditor,
    dealType: formData.dealType,
    githubUrl: formData.githubUrl,
    projectId: formData.projectId,
    language: formData.language,
    dealStatus: dealStatus,
  };
};

// レビューレスポンスからレビューフォームに変換
export const toReviewFormFromReviewResponse = (
  res: ReviewResponse,
): CorporateReviewForm => {
  return {
    dealId: res.dealId,
    dealStatus: res.dealStatus,
    title: res.title,
    purchaseOverview: res.purchaseOverview,
    codeEditor: res.codeEditor,
    amount: res.amount,
    tags: res.tags,
    createDate: res.createDate,
    dealType: res.dealType,
    githubUrl: res.githubUrl,
    fileUrl: res.fileUrl,
    language: res.language,
    projectName: res.projectName,
    projectIconUrl: res.projectIconUrl,
    projectId: res.projectId,
  };
};
